import LazyLoading from "@/components/Wrappers/components/LazyLoading";
import { ButtonFilled, ButtonText } from "@abtasty/design-system";
import { useTranslation } from "react-i18next";
import { ITopBarWrapper } from "./types";

const TopBarWrapper: React.FC<ITopBarWrapper> = ({ wrappedComponent }) => {
  const { t } = useTranslation();
  const goBack = () => {
    window.close();

    if (!window.closed && window.opener) {
      try {
        window.opener = null;
        window.close();
      } catch (e) {
        // ignoré
      }
    }

    if (!window.closed) {
      window.open("about:blank");
      setTimeout(() => {
        try {
          window.close();
        } catch (e) {}
      }, 50);
    }
  };

  return (
    <div>
      <div
        style={{
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          paddingLeft: 16,
          paddingRight: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <ButtonFilled
            variant={"tertiary"}
            size={"large"}
            icon="arrowLeft"
            onClick={goBack}
          />
          <ButtonText
            variant="primary"
            size="medium"
            label={t("back")}
            onClick={goBack}
          />
        </div>
      </div>
      <div
        style={{
          height: "calc(100vh - 64px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <LazyLoading component={wrappedComponent} />
      </div>
    </div>
  );
};

export default TopBarWrapper;
